export class Grupo {
  constructor({ uuid, nome, descricao, numero }) {
    this.uuid = uuid;
    this.nome = nome;
    this.descricao = descricao;
    this.numero = numero;
  }
}
